import { render, staticRenderFns } from "./reccostview.vue?vue&type=template&id=4c6969ac&scoped=true&"
import script from "./reccostview.vue?vue&type=script&lang=js&"
export * from "./reccostview.vue?vue&type=script&lang=js&"
import style0 from "./reccostview.vue?vue&type=style&index=0&id=4c6969ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6969ac",
  null
  
)

export default component.exports